import styled from '@emotion/styled';

export const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
